import { gtcSetPreviousFocus } from "gtcUtils";
import { gtcDrawer } from "gtcOpener";

class GTCTerms extends HTMLElement {
  constructor() {
    super();

    this.validate = this.validate.bind(this);
    this.acceptAndSubmit = this.acceptAndSubmit.bind(this);
    this.keyDownCheckbox = this.keyDownCheckbox.bind(this);
    this.click = this.click.bind(this);
    this.focusCheckbox = this.focusCheckbox.bind(this);
  }

  connectedCallback() {
    this.dom = {
      main: this,
      checkBox: this.querySelector("#GtcTermsCheck"),
    };

    this.settings = {
      ...super.settings,
      formSelector: this.hasAttribute("form-selector")
        ? "#" + this.getAttribute("form-selector")
        : 'form[action="/cart"]',
      parentSelectors: JSON.parse(this.getAttribute("parent-selectors")) || [""],
      submitSelector: this.getAttribute("submit-selector"),
      view: this.getAttribute("view"),
    };
    this.dom.checkBox.removeAttribute("required");

    this.Init();
  }

  disconnectedCallback() {
    this.dom.checkBox.setAttribute("required", true);
    this.removeListeners();
  }

  async Init() {
    this.cartParent = null;
    for (let selector of this.settings.parentSelectors) {
      this.cartParent = this.dom.main.closest(selector);
      if (this.cartParent) {
        break;
      }
    }

    this.cartForm = document.querySelector(this.settings.formSelector);
    this.cartSubmit = this.cartParent.querySelector(this.settings.submitSelector);
    this.cartSubmitDefaultClasses = this.cartSubmit.classList.value;

    this.addListeners();
  }

  focusCheckbox() {
    this.dom.checkBox.focus();
  }

  addListeners() {
    this.cartForm.addEventListener("submit", this.validate);
    this.dom.checkBox.addEventListener("keydown", this.keyDownCheckbox);
    this.addEventListener("click", this.click);
    document.addEventListener("terms:accepted", this.acceptAndSubmit);
    document.addEventListener("terms:declined", this.focusCheckbox);
  }

  removeListeners() {
    this.cartForm.removeEventListener("submit", this.validate);
    this.dom.checkBox.removeEventListener("keydown", this.keyDownCheckbox);
    this.removeEventListener("click", this.click);
    document.removeEventListener("terms:accepted", this.acceptAndSubmit);
    document.removeEventListener("terms:declined", this.focusCheckbox);
  }

  acceptAndSubmit() {
    this.dom.checkBox.checked = true;
    this.cartSubmit.click();
  }

  keyDownCheckbox(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      this.dom.checkBox.checked = !this.dom.checkBox.checked;
    }
  }

  click(e) {
    // id e.target is an achor tag, or gtc-trigger, prevent the default action
    if (e.target.tagName === "A" || e.target.tagName === "GTC-TRIGGER") {
      e.preventDefault();
    }
  }

  validate(e) {
    if (!this.dom.checkBox.checked) {
      e.preventDefault();
      requestAnimationFrame(() => {
        this.cartSubmit.classList.value = this.cartSubmitDefaultClasses;
        this.cartSubmit.setAttribute("aria-busy", false);
      });

      if (document.getElementById("GtcCartTermsDrawer")) {
        gtcSetPreviousFocus(this.dom.checkBox);
        document.getElementById("GtcCartTermsDrawer").open();
      } else {
        confirm("Please accept the terms and conditions");
      }
    }
  }
}

if (!window.customElements.get("gtc-terms")) {
  customElements.define("gtc-terms", GTCTerms);
}

class GTCTermsDrawer extends gtcDrawer {
  constructor() {
    super();
    this.accept = this.accept.bind(this);
    this.decline = this.decline.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();

    this.dom = {
      termsAcceptButton: this.querySelector('[terms="accept"]'),
      termsDeclineButton: this.querySelector('[terms="decline"]'),
    };

    super.settings;
    this.addListeners();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  addListeners() {
    super.addListeners();

    this.dom.termsAcceptButton.addEventListener("click", this.accept);
    this.dom.termsDeclineButton.addEventListener("click", this.decline);
  }

  removeListeners() {
    super.removeListeners();

    if (!this.dom) return;
    this.dom.termsAcceptButton.removeEventListener("click", this.accept);
    this.dom.termsDeclineButton.removeEventListener("click", this.decline);
  }

  async accept() {
    this.close();
    document.dispatchEvent(new CustomEvent("terms:accepted"));
  }

  async decline() {
    this.close();

    requestAnimationFrame(() => {
      document.dispatchEvent(new CustomEvent("terms:declined"));
    });
  }
}

if (!window.customElements.get("gtc-terms-drawer")) {
  customElements.define("gtc-terms-drawer", GTCTermsDrawer);
}
